/**
 * propmate.kr 아래에 따로 올라가 있는 별도 앱 주소.
 * 둘 다 이 SPA 의 라우터 밖이라 <Link> 가 아니라 <a href> 로 전체 이동한다.
 * 절대 경로라 언어 접두사(/en 등)는 붙지 않는다.
 *
 * 로컬 개발 서버(:3000)에는 이 경로들을 넘겨줄 앞단이 없어 이 앱의 빈 라우트가 뜬다.
 * 그래서 개발 중에는 각 앱이 실제로 떠 있는 주소로 보낸다.
 */
const isDev = process.env.NODE_ENV === "development";

/** Madang(AI 건축 설계). 운영은 CloudFront 가 /madang 을 Madang 서버로 넘긴다. */
export const MADANG_URL = isDev ? "https://propmate.kr/madang/app" : "/madang/app";

/**
 * Service 메뉴의 소개 페이지. public/service 의 정적 HTML 이다(피그마 "서비스 - … 설명" 프레임).
 * 라우터 밖이고 한국어뿐이라 언어 접두사 없이 연다.
 */
export const SERVICE_MAP_PAGE = "/service/propmate-map.html";
export const SERVICE_MADANG_PAGE = "/service/madang.html";

/**
 * 3D 스크롤 스토리텔링(propmate_history 저장소). S3 history/ 폴더에 정적 빌드로 올린다.
 * 로컬은 실행 항목 propmate-history-3100 (homepage 가 /history 라 경로가 같다).
 * 운영 CloudFront 오리진이 S3 REST 라 폴더 주소(/history/)는 index.html 로 안 풀리고
 * 루트 SPA 오류 응답이 뜬다(2026-11-02 확인). 그래서 파일 이름까지 적는다.
 */
export const HISTORY_URL = isDev ? "http://localhost:3100/history/" : "/history/index.html";
